import { render, staticRenderFns } from "./ViewRenovationsTable.vue?vue&type=template&id=71482c26"
import script from "./ViewRenovationsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewRenovationsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports